module.exports = __webpack_public_path__ + "static/forest_red-4f312c9fd3a7cc88de5d569511830d7c.jpg";